// extracted by mini-css-extract-plugin
export var active = "bS_bd";
export var answer = "bS_gW";
export var arrow = "bS_9";
export var faq = "bS_hJ";
export var heading = "bS_G";
export var question = "bS_hK";
export var section = "bS_d";